import { render, staticRenderFns } from "./Detalle.vue?vue&type=template&id=3a16a56a"
import script from "./Detalle.vue?vue&type=script&lang=js"
export * from "./Detalle.vue?vue&type=script&lang=js"
import style0 from "./Detalle.vue?vue&type=style&index=0&id=3a16a56a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports